import { useEffect } from 'react';
import { useToast } from '@chikara/ui';
import type { ApiError } from '@chikara/types';
import { t } from '@/i18n';

export function ErrorProvider({ children }: { children: React.ReactNode }) {
  const toast = useToast();

  useEffect(() => {
    const handler = (event: Event) => {
      const error = (event as CustomEvent<ApiError>).detail;

      // 🎯 Mapeo UX 
      switch (error.code) {
        case 'MFA_INVALID_CODE':
          toast.error(t('errorProvider.mfaInvalidCode'));
          break;

        case 'MFA_EXPIRED':
          toast.warning(t('errorProvider.mfaExpired'));
          break;

        case 'LOCATION_REQUIRED':
          toast.warning(t('errorProvider.locationRequired'));
          break;

        default:
          toast.error(error.message || t('errors.default'));
      }
    };

    window.addEventListener('api:error', handler);
    return () => window.removeEventListener('api:error', handler);
  }, [toast]);

  return <>{children}</>;
}
